<template>
  <div>
    <goals-chart-preview-header
      :profile="profile"
      :hide-parent="hideParent"
      :slave-load="slaveLoad"
      :show-global="showGlobal"
      @show-global="showGlobalGoals"/>
    <el-tabs
      v-model="activeName"
      class="tabs"
      @tab-click="handleClick">
      <el-tab-pane
        label="Tractores"
        name="first">
        <goals-chart-preview-table
          :data="monthlyGoalsTractor"
          :profile="profile"
          :title="titles.first"/>
        <div v-if="titles.second !== false">
          <goals-chart-preview-table
            v-if="profile.role === 'gerente_dealer' || profile.role === 'gerente_branch' || profile.role === 'superadmin' && $route.name !== 'goals-target-zone'"
            :data="monthlyAssignGoalsTractor"
            :profile="profile"
            :title="titles.second"/>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="Equipo Forrajero & EE"
        name="second">
        <goals-chart-preview-table
          :data="monthlyGoalsForrajero"
          :profile="profile"
          :title="titles.first"/>
        <div v-if="titles.second !== false">
          <goals-chart-preview-table
            v-if="profile.role === 'gerente_dealer' || profile.role === 'gerente_branch' || profile.role === 'superadmin' && $route.name !== 'goals-target-zone'"
            :data="monthlyAssignGoalsForrajero"
            :profile="profile"
            :title="titles.second"/>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="Implementos"
        name="third">
        <goals-chart-preview-table
          :data="monthlyGoalsImplemento"
          :profile="profile"
          :title="titles.first"/>
        <div v-if="titles.second !== false">
          <goals-chart-preview-table
            v-if="profile.role === 'gerente_dealer' || profile.role === 'gerente_branch' || profile.role === 'superadmin' && $route.name !== 'goals-target-zone'"
            :data="monthlyAssignGoalsImplemento"
            :profile="profile"
            :title="titles.second"/>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="main">
      <el-row>
        <el-col :span="24">
          <div class="header">
            <p>Estos son los objetivos cumplidos y por cumplir en el año actual</p>
          </div>
        </el-col>
        <el-col>
          <div class="count-goals">
            <el-row>
              <el-col :span="8">
                <div class="quantity">
                  <h5>Total de Equipos</h5>
                  <p>{{ calculateTotalGoals }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="quantity">
                  <h5>Realizados</h5>
                  <p>{{ simulateDoneGoals }}</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="quantity">
                  <h5>Pendientes</h5>
                  <p>{{ simulateUndoneGoals }}</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="container-chart">
            <el-row>
              <el-col :span="12">
                <div class="content-chart">
                  <div class="chart">
                    <pie-chart
                      :labels="labelsType"
                      :datasets="calculateType"/>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="content-chart">
                  <div class="chart">
                    <pie-chart
                      :labels="labelsStatus"
                      :datasets="calculateCompleted"/>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="footer-goal"
        type="flex"
        justify="center">
        <el-col :span="8">
          <div class="tractor">
            <h4>Tractor / <strong>{{ tractorGoals }}</strong></h4>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="forrajero">
            <h4>Equipo Forrajero & EE / <strong>{{ forrajeroGoals }}</strong></h4>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="forrajero">
            <h4>Implementos / <strong>{{ implementoGoals }}</strong></h4>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import pieChart from '@/components/_shared/charts/pie-chart'
import GoalsChartPreviewHeader from '@/modules/goals/goals-chart-preview-header'
import GoalsChartPreviewTable from '@/modules/goals/goals-chart-preview-table'

export default {
  name: 'GoalsChartPreview',
  components: {
    pieChart,
    GoalsChartPreviewHeader,
    GoalsChartPreviewTable
  },
  props: {
    goals: {
      type: Array,
      default () {
        return []
      }
    },
    globalGoals: {
      type: Array,
      default () {
        return []
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    metGoals: {
      type: Object,
      default () {
        return {}
      }
    },
    itemType: {
      type: String,
      default: 'dealer' // dealer, branch, seller
    },
    showGlobal: {
      type: Boolean,
      default: true
    },
    hideParent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      labelsStatus: ['Faltantes', 'Cumplidos', 'Implementos', 'Sin Definir'],
      labelsType: ['Forrajero & EE', 'Tractores', 'Implementos', 'Sin Definir'],
      activeName: 'first'
    }
  },
  computed: {
    titles () {
      let txt = 'Objetivos Asignados a'
      switch (this.profile.role) {
        case 'superadmin':
          switch (this.$route.name) {
            case 'goals-dealer':
              return {
                first: `${txt} Distribuidor`,
                second: `${txt} Sucursales`
              }
            case 'admin-goals-branch':
              return {
                first: `${txt} Sucursal`,
                second: `${txt} Vendedores`
              }
            default:
              return {
                first: '',
                second: ''
              }
          }
        case 'gerente_dealer':
          if (this.showGlobal) {
            return {
              first: `${txt} Distribuidor`,
              second: `${txt} Sucursal`
            }
          }
          return {
            first: `${txt} Sucursal`,
            second: `${txt} Vendedores`
          }
        case 'gerente_branch':
          if (this.showGlobal) {
            return {
              first: `${txt} Sucursal`,
              second: `${txt} Vendedores`
            }
          }
          return {
            first: `${txt} Vendedores`,
            second: false
          }
        case 'vendedor_dealer':
          return {
            first: '',
            second: ''
          }
        default:
          return {
            first: '',
            second: ''
          }
      }
    },
    assignedGoals () {
      return this.$store.getters['assignedGoals/item']
    },
    profile () {
      return this.$store.getters['profile/me']
    },
    calculateTotalGoals () {
      return this.forrajeroGoals + this.tractorGoals + this.implementoGoals
    },
    simulateDoneGoals () {
      let _done = 0
      for (const month in this.metGoals) {
        for (const goalKey in this.metGoals[month]) {
          _done += parseInt(this.metGoals[month][goalKey])
        }
      }
      return _done
    },
    simulateUndoneGoals () {
      let total = this.calculateTotalGoals - this.simulateDoneGoals
      return total > 0 ? total : 0
    },
    calculateType () {
      let data = [this.forrajeroGoals, this.tractorGoals, this.implementoGoals]
      if (this.forrajeroGoals === 0 && this.tractorGoals === 0 && this.implementoGoals === 0) {
        data.push(100)
      }
      return [{
        data,
        backgroundColor: [
          '#FF8206',
          '#FF231E',
          '#f4c842'
        ]
      }]
    },
    calculateCompleted () {
      let data = []
      if (this.calculateTotalGoals === 0) {
        data = [0, 0, 0, 100]
      } else {
        data = [this.simulateUndoneGoals, this.simulateDoneGoals]
      }
      return [{
        data: data,
        backgroundColor: [
          '#9D9D9D',
          '#30B122'
        ]
      }]
    },
    forrajeroGoals () {
      return this.calculateGoals('Equipo Forrajero')
    },
    tractorGoals () {
      return this.calculateGoals('Tractor')
    },
    implementoGoals () {
      return this.calculateGoals('Implemento')
    },
    slaveLoad () {
      let itemValue = ''
      if (this.item) {
        switch (this.itemType) {
          case 'dealer':
            itemValue = this.item.name
            break
          case 'branch':
            itemValue = this.item.city
            break
          case 'seller':
          case 'territorial':
            itemValue = `${this.item.firstName} ${this.item.lastName}`
            break
        }
      }
      return itemValue
    },
    monthlyGoalsTractor () {
      return this.monthGoals('Tractor', 'tractors', 'metGoals')
    },
    monthlyGoalsForrajero () {
      return this.monthGoals('Equipo Forrajero', 'forrajero', 'metGoals')
    },
    monthlyGoalsImplemento () {
      return this.monthGoals('Implemento', 'implemento', 'metGoals')
    },
    monthlyAssignGoalsTractor () {
      // return this.monthGoals('Tractor', 'tractors', 'assignedGoals')
      return this.assigned('Tractor', 'tractors')
    },
    monthlyAssignGoalsForrajero () {
      // return this.monthGoals('Equipo Forrajero', 'forrajero', 'assignedGoals')
      return this.assigned('Equipo Forrajero', 'forrajero')
    },
    monthlyAssignGoalsImplemento () {
      // return this.monthGoals('Implemento', 'implemento', 'assignedGoals')
      return this.assigned('Implemento', 'implemento')
    }
  },
  methods: {
    monthGoals (type, key, goalKey) {
      let _goals = []
      let labels = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
      let filteredGoals = this.goals.filter(goal => goal.type === type)
      let filteredGlobalGoals = this.globalGoals.filter(goal => goal.type === type)
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i]
        let value = i + 1
        let found = filteredGoals.find(goal => goal.month === value)
        let foundGlobal = filteredGlobalGoals.find(goal => goal.month === value)
        let totalGoal = 0
        let doneGoal = 0
        if (found) {
          let _key = found.month < 10 ? `0${found.month}` : found.month
          totalGoal = goalKey === 'assignedGoals' ? parseInt(foundGlobal.sales) : parseInt(found.sales)
          doneGoal = parseInt(this[goalKey][_key][key])
        }
        _goals.push({
          label,
          value,
          totalGoal,
          doneGoal
        })
      }
      return _goals.sort((a, b) => a.value - b.value)
    },
    assigned (type, key) {
      let _goals = []
      let labels = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
      let filteredGoals = this.goals.filter(goal => goal.type === type)
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i]
        let value = i + 1
        let found = filteredGoals.find(goal => goal.month === value)
        let totalGoal = 0
        let doneGoal = 0
        if (found) {
          let _key = found.month < 10 ? `0${found.month}` : found.month
          totalGoal = parseInt(this['assignedGoals'][_key][key])
          doneGoal = parseInt(this['metGoals'][_key][key])
        }
        _goals.push({
          label,
          value,
          totalGoal,
          doneGoal
        })
      }
      return _goals.sort((a, b) => a.value - b.value)
    },
    calculateGoals (type) {
      let filteredGoals = this.goals.filter(goal => goal.type === type)
      if (filteredGoals) {
        return filteredGoals.reduce((a, b) => {
          return a + parseInt(b.sales)
        }, 0)
      }
      return 0
    },
    slaveLoadGoals () {
      this.$router.push({...this.$route, name: 'goals-seller', params: {...this.$route.params, branchId: this.profile.branchId}})
    },
    onClickSlave () {
      if (this.profile.role === 'vendedor_dealer') {
        this.$router.push({...this.$route, name: 'seller-my-goals'})
      } else {
        this.$router.push({...this.$route, name: 'goals-seller', params: {...this.$route.params, branchId: null}})
      }
    },
    showGlobalGoals (val) {
      this.$emit('show-global', val)
    },
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}

</script>

<style scoped lang="scss">
  .tabs {
    background-color: #FFF;
    border: 1px solid #F6F6F6;
    padding: 10px;
  }
  .main {
      border: 1px solid $border-primary;
      border-radius: 3px;
      margin: 20px 0px 20px 0px;
      background-color: #ffffff;
      .header{
        height: 70px;
        background-color: #EFEFEF;
        padding: 15px 30px 0 30px;
        h5{
          margin: 0;
          font-weight: bold;
        }
        p{
          margin: 0;
        }
      }
      .count-goals{
        .quantity{
          min-height: 100px;
          padding-left: 20px;
          padding-top: 20px;
          border-bottom: 1px solid $border-primary;
          border-left: 1px solid $border-primary;
          h5{
            margin: 0;
          }
          p{
            @include font-primary(40px, regular);
            margin: 0;
          }
        }
      }
      .content-chart{
        p{
          text-align: center;
          @include font-lato(16px, bold)
        }
        .chart{
          height: 240px;
          margin-bottom: 20px;
          h5{
            margin: 0px;
          }
        }
      }
      .footer-goal{
        border-top: 1px solid $border-primary;
        height: 60px;
        .forrajero, .tractor{
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/modules/goals/goals-chart-preview.vue